<div *ngIf="value != null" class="container">
    <!-- [hidden] i no *ngIf per no perdre la firma que s'estigui dibuixant mentre s'informa d'un problema o es comenta -->
    <div [hidden]="showPhaseConsignee || signingPanel != null">
  
        <div class="block-title">
            <div class="text-loadunload">{{ getResourcePhase() | translate }}</div>
            <div class="title">{{ value.addressTitle }}</div>
            <div class="subtitle">{{ value.addressLine1 }}</div>
        </div>
        
        <shared-cmr-qr-component *ngIf="value.isUnload && doAction" [agent]="'consignee'" [uuidQR]="phaseUUID"></shared-cmr-qr-component>
        
        <div class="check" *ngIf="value.showIsSignedSender">
            <i class="fa" [ngClass]="getClassIcon(value.isSignedSender)" aria-hidden="true"></i>
            <span class="text">{{'SHARED.EXTERNAL.CMR.PHASE.ISSIGNEDSENDER' | translate }}</span>
            <button-link *ngIf="value.hasAccessSignature" variant="action" class="left" (linkClick)="toggleSigning(RoutePartCMRSignatureAgents.sender)">{{ getResourceGoToSignature(sender, value.isSignedSender) | translate }}</button-link>
        </div>
        <div class="check" *ngIf="value.showIsSignedDriver">
            <i class="fa" [ngClass]="getClassIcon(value.isSignedDriver)" aria-hidden="true"></i>
            <span class="text">{{'SHARED.EXTERNAL.CMR.PHASE.ISSIGNEDDRIVER' | translate }}</span>
            <button-link *ngIf="value.hasAccessSignature" variant="action" class="left" (linkClick)="toggleSigning(RoutePartCMRSignatureAgents.driver)">{{ getResourceGoToSignature(driver, value.isSignedDriver) | translate }}</button-link>
        </div>
        <div class="check" *ngIf="value.showIsSignedConsignee">
            <i class="fa" [ngClass]="getClassIcon(value.isSignedConsignee)" aria-hidden="true"></i>
            <span class="text">{{'SHARED.EXTERNAL.CMR.PHASE.ISSIGNEDCONSIGNEE' | translate }}</span>
            <button-link *ngIf="value.hasAccessSignature" variant="action" class="left" (linkClick)="toggleSigning(RoutePartCMRSignatureAgents.consignee)">{{ getResourceGoToSignature(consignee, value.isSignedConsignee) | translate }}</button-link>
        </div>

        <ng-container *ngIf="signingAgent != null">
            <div class="signing-block">
                <div class="signing-header">
                    <button class="btn-signing-close" (click)="closeSigning()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
                <shared-sign-cmr-maintenance [signUUID]="phaseUUID" [type]="signingAgent"
                    (signedChanged)="onSigned()">
                    <shared-external-cmr-agent-phase-signactions sign-extra-actions [phaseUUID]="phaseUUID"
                        [agent]="agent" (reportProblem)="openSigningPanel('INCIDENT')" (addComment)="openSigningPanel('COMMENT')"
                        (resolveStandStill)="openSigningPanel('STANDSTILL')"></shared-external-cmr-agent-phase-signactions>
                </shared-sign-cmr-maintenance>
            </div>
        </ng-container>

        <ng-container *ngIf="signingAgent == null">
            <div class="bar">
                <div class="baroptions">
                    <options class="nomenu" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
                </div>
                <div class="baractions">
                    <shared-route-ecmr-actions [onlyIcons]="true" [phaseUUID]="phaseUUID"></shared-route-ecmr-actions>
                </div>
            </div>
            <shared-route-part-cmr-digitaldocument-component class="no-actions-rpc" *ngIf="optionSelected != 'GENERAL' && getRoutePartCMRId() > 0" [external]="true" [routePartCMRId]="getRoutePartCMRId()" [avoidOptionFirma]="true">
            </shared-route-part-cmr-digitaldocument-component>
            <div *ngIf="optionSelected == 'GENERAL'">                
                <shared-route-part-cmr-digitaldocument-component class="no-actions-rpc" *ngFor="let rpc of value.cmrs" [external]="true" [routePartCMRId]="rpc.routePartCMRId" [avoidOptionFirma]="true">
                </shared-route-part-cmr-digitaldocument-component>        
            </div>
            <shared-documentaryreview-item-documents-component class="block-data"
                    [parentObject]="parentObject" (dataRefresh)="onDocumentValueChanged()"
                    [resourceTitle]="'DOCUMENTARYREVIEW.IMPORT.TITLE'"></shared-documentaryreview-item-documents-component>
    
        </ng-container>

    </div>
    <shared-external-cmr-agent-incident *ngIf="signingPanel == 'INCIDENT'" [phaseUUID]="phaseUUID" [agent]="agent"
        (done)="onSigningPanelDone($event)"></shared-external-cmr-agent-incident>
    <shared-external-cmr-agent-standstill *ngIf="signingPanel == 'STANDSTILL'" [phaseUUID]="phaseUUID" [agent]="agent"
        (done)="onSigningPanelDone($event)"></shared-external-cmr-agent-standstill>
    <shared-external-cmr-agent-phase-comment *ngIf="signingPanel == 'COMMENT'" [phaseUUID]="phaseUUID" [agent]="agent"
        (done)="onSigningPanelDone($event)"></shared-external-cmr-agent-phase-comment>
    <shared-external-cmr-agent-phase *ngIf="showPhaseConsignee" [agent]="'consignee'" [phaseUUID]="phaseUUID"></shared-external-cmr-agent-phase>
    <div class="dummy"></div>
</div>